import React from 'react';
import { ExcelTableCellProps } from './TableCell';
import { observer } from 'mobx-react';
import { getIframe } from '../../apis/card';
import { message } from 'antd';
import { MyWindow } from '../../util';
import _ from 'lodash';
import jQuery from "jquery";
import  { CellProps } from '../../stores/card/ModeExcel';
import CardStore from '../../stores/card';

interface ExcelTableCellDivProps{
    cell: CellProps;
    card: CardStore;
}

@observer
export default class ExcelTableCellDiv extends React.Component<ExcelTableCellDivProps, any> {
    fixedHeight: any;
    constructor(props: ExcelTableCellProps) {
        super(props);
        this.state = {
            innerHtml: ''
        }
    }
    fixed = () => {
        const { cell } = this.props;
        if (cell.evalue != "#QRCodeImg#" && cell.evalue != "#BARCodeImg#") {
            if (cell.jsonparam&&cell.jsonparam.set_height != undefined && cell.jsonparam.set_height == 'auto') {
                let height = 0;
                this.fixedHeight = setInterval(() => {
                    try {
                        const iframe = jQuery(this.refs._containter).find('iframe');
                        if (iframe[0]) {
                            const perfectHeight = ((iframe[0] as HTMLIFrameElement).contentWindow as MyWindow).perfectHeight;
                            if (_.isFunction(perfectHeight)) {
                                const newHeight = perfectHeight();
                                if (newHeight && !isNaN(newHeight) && height != newHeight) {
                                    height = newHeight;
                                    iframe.height(newHeight);
                                    clearInterval(this.fixedHeight);
                                }
                            }
                        }
                    } catch (e) {
                        clearInterval(this.fixedHeight);
                    }
                }, 100)
            }
        }
    }
    componentWillUpdate() {
        this.fixed();
    }
    componentDidUpdate(){
        const tabledom = jQuery(jQuery(this.refs._containter).find('table'));
        const H = tabledom.height();
        const W = tabledom.width();
        H && jQuery(this.refs._containter).css({height:H,width:W});
    }
    componentDidMount() {
        const {cell, card } = this.props;
        this.getCodeImg();
        const key = cell.row+'_'+cell.col;
        card.modeExcel.addCodeFn({[key]:this.getCodeImg});
    }
    getCodeImg = () => {
        const { cell, card } = this.props;
        let etype = cell.etype;
        if (cell.evalue == "#QRCodeImg#" || cell.evalue == "#BARCodeImg#") {
            etype = "17";
        }
        getIframe({ ...card.base, ...cell.jsonparam, etype: etype, evalue: cell.evalue }).then(({ status, errorCode, error, htmlstr }) => {
            if (status == '1') {
                this.setState({ innerHtml: htmlstr });
                this.fixed();
            } else {
                message.error(`[${errorCode}]:${error}`);
            }
        });
    }
    render() {
        const { cell } = this.props;
        return (
            <div className="codeContainer" ref="_containter" {...cell.cellProps} dangerouslySetInnerHTML={{ __html: this.state.innerHtml }} />
        )
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/CellDiv.tsx